enum BiteLogDeviceEvent {
  OK = 0,
  LowBattery = 1,
  ExitMenuToConfigScreen = 2,
  ConfigChange = 3,
  ReachabilityOK = 5,
  ReachabilityNone = 6,
  GcnJsCrash = 7,
  /** @deprecated */
  ApnReceivedDeprecated = 8,
  GcnJsError = 9,
  FailedToStartWebView = 12,
  RecoveredFromCrash = 13,
  FailedToEnterASAM = 14,
  FailedToExitASAM = 15,
  FailedOrderValidation = 16,
  MemoryWarning = 18,
  ReloadHTML = 19,
  EmptyJS = 20,
  BridgeEvalError = 21,
  WebViewDidCommitNavigation = 22,
  WebViewDidTerminate = 23,
  WebViewFailedProvisionalNavigation = 24,
  WebViewRedirectProvisionalNavigation = 25,
  ErrorSendingOrder = 26,
  NoNotificationPermissions = 28,
  CrashlyticsCrash = 29,
  BatteryDepleting = 30,
  Push = 31,
  BluetoothStateChange = 32,
  BatteryStateChange = 33,
  ManualAppRestart = 34,
  RemoteTestPrintSuccess = 35,
  RemoteTestPrintError = 36,
  SessionStarted = 37,
  ApplicationIsBeingTerminated = 38,
  StartFail = 39,
  SelfDestructNoPayment = 40,
  SelfDestructNoKitchenPrinter = 41,
  SelfDestructNoReceiptPrinter = 42,
  FailedToDownloadMenuAssets = 43,
  WhitelistTestSuccess = 44,
  WhitelistTestFailure = 45,
  SelfDestructMaxSessionCountReached = 46,
  ScannerData = 47,
  CameraInitializationError = 48,
  JawsError = 49,
  AppUpdate = 50,
  FailedOrderCreation = 51,
  SessionEnded = 52,
  JawsLicense = 53,
  ApplicationIsBeingLoggedOut = 54,
  MenuCoverTapped = 55,
  EnteredMenu = 56,
  ScaleData = 57,
  ScaleLog = 58,
  NativeLog = 59,
  NativeTransactionStarted = 60,
  NativeTransactionFinished = 61,
  KioskEnteredMaintenanceMode = 62,
  KioskExitedMaintenanceMode = 63,
  GarconJsCrash = 64,
  VitrineJsCrash = 65,
  VitrineHealthCheckSuccessDeprecated = 67,
  VitrineHealthCheckFailed = 66,
  GarconHealthCheckFailed = 68,
  NativeFailure = 69,
  VitrineNetworkError = 70,
  KioskUpdatedMaintenanceMode = 71,
  NativeTouchGestureBlocked = 72,
  NativeTouchGestureOk = 73,
  SpeedTestResults = 74,
  KioskReady = 75,
  GarconNetworkError = 76,
}

export { BiteLogDeviceEvent };
